import { usePartnerConfig } from "./usePartnerConfig";

export const usePayrollAnomalies = () => {
  const { enabledFeatures } = usePartnerConfig();

  return {
    disablePayrollAnomaly: enabledFeatures.indexOf("provider_payroll_anomaly") === -1 && enabledFeatures.indexOf("provider_test_unreleased_features") === -1,
  };
};
